<template>
  <b-container
    tag="section"
    class="dashboard notifications">
    <b-row>
      <b-col md="12">
        <h2 class="dashboard__title">
          Notifications
        </h2>
      </b-col>
      <b-col md="12">
        <div>
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <router-link
                :to="{name: 'SentNotifications'}"
                active-class="active"
                class="nav-link">Sent</router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{name: 'TemplateMessages'}"
                active-class="active"
                class="nav-link">Templates</router-link>
            </li>
          </ul>
        </div>
        <div class="my-5">
          <router-view/>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Notifications',
};
</script>
